module.exports = __webpack_public_path__ + "static/english_circle_3-bf9fe8b27b98bb8bd2a84124d4a3bcdd.svg";